import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { CompanyFlagCompositeEntity, CompanyFlagTypeEntity } from '@nk/data-entities-lib';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { CompanyFlagContextContentComponent } from '../company-flag-context/company-flag-context-content.component';
import { CompanyFlagIconComponent } from '../company-flag-icon/company-flag-icon.component';

export type CompanyFlagTagIconVariant = 'default' | 'dashboard';
export type CompanyFlagTagSize = 'default' | 'large';

@Component({
  selector: 'nk-company-flag-tag',
  imports: [CompanyFlagIconComponent, CompanyFlagContextContentComponent, PopoverModule, TranslateModule],
  templateUrl: './company-flag-tag.component.html',
  styleUrls: ['./company-flag-tag.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CompanyFlagTagComponent {
  public item = input<CompanyFlagTypeEntity | undefined>();
  public composite = input<CompanyFlagCompositeEntity | undefined>();
  public iconVariant = input<CompanyFlagTagIconVariant>('default');
  public size = input<CompanyFlagTagSize>('default');

  public flagType = computed(() => this.composite()?.company_flag_type ?? this.item());
}
